<template>
  <div>
    <el-dialog
      title="非券订单佣金设置"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="!saveLoading"
      :before-close="handleBeforeClose"
      append-to-body
      width="700px"
      custom-class="non-coupon-commission-dialog"
      @closed="handleClosed"
    >
      <div class="commission-setting__description">
        <p>①团长本月已核销券销售金额 占 全平台已核销券销售金额比例。</p>
        <p>②本月全抖音poi核销小程序 非券订单总成交订单金额(不含关单)。</p>
        <p style="font-weight: 700;">团长非券订单佣金：②x①x下方佣金比例。</p>
        <p class="commission-setting__example-title">示例：</p>
        <p>8月1日至15日：佣金率2%</p>
        <p>8月16日起：佣金率1.5%</p>
        <p>费率变化前非用券成交120万</p>
        <p>费率变化后非用券成交80万</p>
        <p>机构最终月度占比10%</p>
        <p>则：</p>
        <p>变化前佣金：120万 x 10% x 2% = 2400元</p>
        <p>变化后佣金：80万 x 10% x 1.5% = 1200元</p>
        <p>月度总佣金：2400 + 1200 = 3600元</p>
      </div>
      <div style="margin-top: 10px;">已选中：{{ userUUIDs.length }}</div>
      <el-form
        ref="commissionFormRef"
        :model="form"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item
          class="commission-setting__form-item"
          label="非券订单佣金设置："
          prop="commissionRate"
        >
          <div class="commission-setting__control">
            <el-input
              v-model.trim="form.commissionRate"
              class="commission-setting__input"
              maxlength="6"
            />
            <span>%</span>
            <el-button v-if="!isBatch" type="text" @click="handleOpenRecord">修改记录</el-button>
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <div class="commission-setting__effective-tip">设置后明日0点生效。</div>
        <div>
          <el-button :disabled="saveLoading" @click="handleClose">取 消</el-button>
          <el-button type="primary" :loading="saveLoading" :disabled="saveLoading" @click="handleConfirm">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <commission-change-record ref="commissionChangeRecordRef" />
  </div>
</template>

<script>
import CommissionChangeRecord from './commissionChangeRecord.vue'
import poi from '@/api/poi'

const COMMISSION_RATE_PATTERN = /^(?:(?:0|[1-9]\d?)(?:\.\d{1,2})?|100(?:\.0{1,2})?)$/
const PoiModel = new poi()

export default {
  name: 'NonCouponCommissionSetting',
  components: {
    CommissionChangeRecord
  },
  data() {
    return {
      dialogVisible: false,
      isBatch: false,
      userUUIDs: [],
      row: null,
      saveLoading: false,
      form: {
        commissionRate: ''
      },
      rules: {
        commissionRate: [
          {
            required: true,
            message: '请输入佣金比例',
            trigger: ['blur', 'change']
          },
          {
            pattern: COMMISSION_RATE_PATTERN,
            message: '请输入0-100的数字，最多保留2位小数',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  methods: {
    open({ isBatch = false, userUUIDs = [], row = null } = {}) {
      this.resetState()
      this.isBatch = isBatch
      this.userUUIDs = Array.isArray(userUUIDs) ? [...userUUIDs] : []
      this.row = row
      const commissionRate = row && row.nonCouponCommissionRate
      this.form.commissionRate = !isBatch && commissionRate != null
        ? String(commissionRate)
        : ''
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.commissionFormRef && this.$refs.commissionFormRef.clearValidate()
      })
    },
    handleOpenRecord() {
      if (!this.row) return
      this.$refs.commissionChangeRecordRef.open({
        userUUID: this.row.userUUID
      })
    },
    handleConfirm() {
      if (this.saveLoading) return
      this.saveLoading = true
      this.$refs.commissionFormRef.validate(valid => {
        if (!valid) {
          this.saveLoading = false
          return
        }
        this.saveCommissionRate()
      })
    },
    async saveCommissionRate() {
      const userUUIDs = [...this.userUUIDs]
      if (userUUIDs.length === 0 || userUUIDs.some(userUUID => !userUUID)) {
        this.saveLoading = false
        this.$message.error('团长UUID不能为空')
        return
      }
      try {
        const res = await PoiModel.batchSaveNonCouponCommissionRate({
          userUUIDs: [...new Set(userUUIDs)],
          commissionRate: Number(this.form.commissionRate)
        })
        if (!res || !res.data || res.data.code !== 200) {
          this.$message.error(res && res.data && res.data.message ? res.data.message : '设置失败')
          return
        }
        this.$message.success(res.data.message || '设置成功')
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error && error.message
            ? error.message
            : '设置失败，请稍后重试'
        this.$message.error(message)
      } finally {
        this.saveLoading = false
      }
    },
    handleClose() {
      if (this.saveLoading) return
      this.dialogVisible = false
    },
    handleBeforeClose(done) {
      if (this.saveLoading) return
      done()
    },
    handleClosed() {
      this.$refs.commissionChangeRecordRef && this.$refs.commissionChangeRecordRef.close()
      this.resetState()
    },
    resetState() {
      this.dialogVisible = false
      this.isBatch = false
      this.userUUIDs = []
      this.row = null
      this.saveLoading = false
      this.form.commissionRate = ''
      this.$refs.commissionFormRef && this.$refs.commissionFormRef.clearValidate()
    }
  }
}
</script>

<style scoped lang="less">
.commission-setting {
  &__form-item {
    margin-top: 16px;
    margin-bottom: 18px;
  }

  &__control {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__input {
    width: 70px;
  }

  &__effective-tip {
    color: #e13b3b;
    line-height: 20px;
  }

  &__description {
    padding: 14px 16px;
    background: #f5f7fa;
    color: #606266;
    line-height: 22px;
    word-break: break-word;

    p {
      margin: 0;
    }
  }

  &__example-title {
    margin-top: 10px !important;
  }
}

/deep/ .non-coupon-commission-dialog {
  max-width: calc(100vw - 32px);

  .el-dialog__body {
    max-height: calc(100vh - 180px);
    overflow-y: auto;
  }
}
.dialog-footer{
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/commissioSetting/nonCouponCommissionSetting.vue